<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Kullanıcı</label>
            <v-select-list :options="users" v-model="user" v-on:input="getEmployeeKasa" label="Combine" placeholder="Kullanıcı"></v-select-list>
        </div>
        <div class="col-12">
            <label class="form-label">Kasalar</label>
            <v-select-list  v-model="kasa" multiple :disabled="user == null || getting" :options="kasaList" label="KSMAS_NAME" placeholder="Kasa" :loading="kasaLoading || getting"></v-select-list>
        </div>
    </div>
</template>

<script>
import UserApi from '@/api/user'
import NetsisOperationsApi from '@/api/netsis-operations'

export default {
    props:{
        value:Object
    },
    data(){
        return {
            users:[],
            kasaList:[],
            lasaLoading:false,
            getting:false
        }
    },
    mounted(){
        this.getUsers()
        this.getKasaList()
    },
    methods:{
        getUsers(){
            UserApi.EmployeeListUser().then(response=>{
                this.users = response.data.Data?.map(u => ({
                    ...u,
                    Combine:`${u.EmployeeFullName} (${u.Username})`
                }))
            })
        },
        getKasaList(){
            this.kasaLoading = true
            NetsisOperationsApi.GetKasaList().then(res => {
                    this.kasaList = res.data.Data
                    this.kasaLoading = false
            }).catch(err=> {
                console.log(err)
                this.kasaLoading = false
            })
        },
        getEmployeeKasa(){
            if(this.user){
                this.getting = true
                NetsisOperationsApi.UserOfNetsisKasa.GetUserOfNetsisKasa(this.user.Id).then(res => {
                    this.value.KasaKodlari = res.data?.Data?.KasaList?.map(k => k.KasaKod) || []
                    this.getting = false
                })
            }else{
                this.value.KasaKodlari = []
            }
        }
    },
    computed:{
        user:{
            get:function(){
                return this.users.find(s=>s.Id==this.value.UserId)
            },
            set:function(value){
                this.value.UserId = value?.Id || null
            }
        },
        kasa:{
            get:function(){
                return this.kasaList.filter(s=>this.value.KasaKodlari.includes(s.KSMAS_KOD))
            },
            set:function(value){
                this.value.KasaKodlari = value?.map(v => v.KSMAS_KOD) || null
            }
        },

    }
}
</script>